package com.sweetlime.dungeonamigo.di

import com.sweetlime.dungeonamigo.api.Open5eApi
import com.sweetlime.dungeonamigo.cache.DatabaseDriverFactory
import com.sweetlime.dungeonamigo.cache.SrdCacheManager
import com.sweetlime.dungeonamigo.cache.SrdDatabase
import com.sweetlime.dungeonamigo.compendium.CompendiumRepository
import com.sweetlime.dungeonamigo.compendium.CompendiumViewModel
import com.sweetlime.dungeonamigo.presentation.features.auth.AuthViewModel
import com.sweetlime.dungeonamigo.presentation.features.character.CharacterViewModel
import com.sweetlime.dungeonamigo.presentation.features.dice.DiceViewModel
import com.sweetlime.dungeonamigo.presentation.features.profile.ProfileViewModel
import com.sweetlime.dungeonamigo.presentation.features.session.SessionViewModel
import com.sweetlime.dungeonamigo.presentation.navigation.NavigationController
import com.sweetlime.dungeonamigo.repository.AuthRepository
import com.sweetlime.dungeonamigo.repository.CharacterRepository
import com.sweetlime.dungeonamigo.repository.FirebaseAuthRepository
import com.sweetlime.dungeonamigo.repository.FirebaseCharacterRepository
import com.sweetlime.dungeonamigo.repository.FirebaseSessionRepository
import com.sweetlime.dungeonamigo.repository.FirebaseUserRepository
import com.sweetlime.dungeonamigo.repository.SessionRepository
import com.sweetlime.dungeonamigo.repository.UserRepository
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.FirebaseFirestoreSettings
import dev.gitlive.firebase.firestore.firestore
import dev.gitlive.firebase.firestore.firestoreSettings
import dev.gitlive.firebase.firestore.persistentCacheSettings
import org.koin.dsl.module

val appModule = module {

    single {
        Firebase.firestore.apply {
            runCatching {
                settings = firestoreSettings {
                    cacheSettings = persistentCacheSettings {
                        sizeBytes = FirebaseFirestoreSettings.CACHE_SIZE_UNLIMITED
                    }
                }
            }
        }
    }

    single<AuthRepository> { FirebaseAuthRepository() }
    single<UserRepository> { FirebaseUserRepository(get(), get()) }

    single { Open5eApi(get()) }
    single { SrdDatabase(get<DatabaseDriverFactory>().createDriver()) }
    single { SrdCacheManager(get(), get()) }
    single { CompendiumRepository(get()) }

    single<CharacterRepository> { FirebaseCharacterRepository(get()) }
    single<SessionRepository> { FirebaseSessionRepository(get()) }

    single { NavigationController() }

    single { AuthViewModel(get(), get()) }
    single { CompendiumViewModel(get(), get()) }
    single { CharacterViewModel(get(), get(), get()) }
    single { DiceViewModel() }
    single { SessionViewModel(get(), get(), get(), get()) }
    single { ProfileViewModel(get(), get(), get()) }
}